/**
 * The old remote-control address (`/remote/:deviceId/:view`): the machine's page is the one place now, so the
 * address opens it with the same view (`/workbenches/:deviceId?view=`), keeping any other query (a session to open).
 */

import { Navigate, useLocation, useParams } from 'react-router-dom';

export function RemoteRedirect() {
  const { deviceId = '', view } = useParams();
  const { search } = useLocation();
  const q = new URLSearchParams(search);
  if (view && !q.has('view')) q.set('view', view);
  // The old Chat view took `?session=<sessionId>`; Sessions takes the live view's key.
  const s = q.get('session');
  if (s && !/^[sc]:/.test(s)) q.set('session', `s:${s}`);
  const rest = q.toString();
  return <Navigate to={`/workbenches/${encodeURIComponent(deviceId)}${rest ? `?${rest}` : ''}`} replace />;
}
